import React, { useMemo, useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import TableToolbar from '../tableToolbar';
import { formatDateMMDDYY } from '../../utilities/dateHelpers';
import { convertKeyToLabel } from '../../utilities/stringHelpers';
import { datagridsx } from '../../constants/datagridsx';
import { colors } from '../../constants';

function dateFormatter(params) {
    return params ? formatDateMMDDYY(new Date(params)) : '';
}

function currencyFormatter(value) {
    if (!value) {
        return '';
    }
    let formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2,
    });
    return formatter.format(value);
}

function renderHeader(params) {
    const label = params.colDef.headerName || params.field;
    const [table, field] = label.split('&');
    return (
        <div
            style={{
                whiteSpace: 'normal',
                lineHeight: 'normal',
                fontWeight: '700',
                color: colors.skyfallDark,
            }}
        >
            <div>{convertKeyToLabel(table)}</div>
            <div>{convertKeyToLabel(field)}</div>
        </div>
    );
}

function DataGridTable({ rows, columns }) {
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
    });

    const tableColumns = useMemo(() => {
        return columns.map((col) => {
            const def = { ...col };
            def.renderHeader = renderHeader;
            switch (col.type) {
            case 'date':
                def.valueFormatter = dateFormatter;
                def.width = 125;
                break;
            case 'currency':
                def.align = 'right';
                def.valueFormatter = currencyFormatter;
                def.width = 150;
                break;
            default:
                def.flex = 1;
                break;
            }
            return def;
        });
    }, [columns]);

    return (
        <div
            className="w-100"
            style={{ height: '100vh', background: colors.backgroundMedium }}
        >
            <DataGridPro
                rows={rows}
                columns={tableColumns}
                autoPageSize={true}
                pagination={true}
                slots={{
                    toolbar: TableToolbar,
                }}
                slotProps={{
                    pagination: {
                        showFirstButton: true,
                        showLastButton: true,
                    },
                    toolbar: { fileName: 'datagrid' },
                }}
                columnVisibilityModel={columnVisibilityModel}
                onColumnVisibilityModelChange={(newModel) =>
                    setColumnVisibilityModel(newModel)
                }
                rowHeight={32}
                sx={{
                    ...datagridsx,
                    '& .MuiDataGrid-columnHeader': {
                        whiteSpace: 'normal',
                        lineHeight: '1.2',
                        alignItems: 'start',
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        whiteSpace: 'normal',
                        overflow: 'visible',
                        textOverflow: 'clip',
                    },
                }}
            />
        </div>
    );
}

export default DataGridTable;
